import React, { Component } from 'react';
import { getText } from '../config';

class SelectPassengers extends Component {
    static defaultProps = {
        childAges: []
    }

    constructor(props) {
        super(props)

        this.state = {
            value: 1
        }

        this.selectAgesMenu = this.selectAgesMenu.bind(this)
        this.addClick = this.addClick.bind(this)
        this.lessClick = this.lessClick.bind(this)
    }

    selectAgesMenu() {
        this.props.selectAges(true, this.props.roomId)
    }

    addClick() {
        this.props.addClick()
        if(this.props.isMobile && this.props.icon.indexOf('child') !== -1 && this.props.searchType === 'hotel') this.selectAgesMenu();
    }

    lessClick() {
        this.props.lessClick()
        if(this.props.isMobile && this.props.icon.indexOf('child') !== -1 && this.props.searchType === 'hotel' && this.props.value > 1) this.selectAgesMenu();
    }

    render() {

        return (
            <div className={"select-passengers-row" + (this.props.last ? " last" : "") + (this.props.childAges.length > 0 ? " normal" : "")}>
                <div className={"passengers-icon " + (this.props.icon || "")}>
                    <img src={this.props.icon + "-icon.png"} alt={this.props.text} />
                </div>
                <div className="passengers-text">
                    <div className="text-big">{this.props.text}</div>
                    {this.props.subText && <div className="text-small">{this.props.subText}</div>}
                </div>
                <div className="passengers-button">
                    <button className="button" onClick={this.addClick}>
                        <img src="./img/plus-icon.png" alt="+" />
                    </button>
                    <div className="value">
                        {this.props.value}
                    </div>
                    <button className="button" onClick={this.lessClick}>
                        <img src="./img/minus-icon.png" alt="-" />
                    </button>
                </div>
                {this.props.childAges.length > 0 && !this.props.isMobile && <div className="passengers-ages">
                    <div className="ages-title">{getText('selectChildAge')}</div>
                    {this.props.childAges.map((age, i) => {
                        return <SelectPassengers
                            key={"age_" + i}
                            value={age}
                            addClick={this.props.addClickAge.bind(null, i)}
                            lessClick={this.props.lessClickAge.bind(null, i)}
                        />
                    })}
                </div>}
            </div>
        );
    }
}

SelectPassengers.propTypes = {
    //myProp: PropTypes.type.isRequired
};

export default SelectPassengers;


// WEBPACK FOOTER //
// ./src/components/SelectPassengers.js